/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Dark_Goat_LiftInputs */

const en_sharp_dark_goat_lift = /** @type {(inputs: Sharp_Dark_Goat_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has results`)
};

const de_sharp_dark_goat_lift = /** @type {(inputs: Sharp_Dark_Goat_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat Ergebnisse`)
};

/**
* | output |
* | --- |
* | "Has results" |
*
* @param {Sharp_Dark_Goat_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sharp_dark_goat_lift = /** @type {((inputs?: Sharp_Dark_Goat_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Dark_Goat_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharp_dark_goat_lift(inputs)
	return de_sharp_dark_goat_lift(inputs)
});